import React from 'react';
import { StyleSheet, View } from 'react-native';
import { QRCode, theme } from '@sweetgreen/garnish';

type Props = Pick<React.ComponentProps<typeof QRCode>, 'value'>;

export const ScanToPayQrCode = (props: Props) => {
  const { value } = props;

  return (
    <View style={styles.wrapper}>
      <QRCode value={value} style={styles.qrCode} />
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.medium,
  },
  qrCode: {
    height: 242, // from figma
  },
});
